import { mode } from "@chakra-ui/theme-tools";

// Tokens from https://naturalremediesapp.com/
// --green #073205, --ink #111812, --muted #3d433e, --surface #f6f7f9, --glow #8be15a
export const globalStyles = {
  colors: {
    brand: {
      50: "#E8F6E3",
      100: "#D4E8C8",
      200: "#8BE15A",
      300: "#4FA03A",
      400: "#1F5A1C",
      500: "#073205",
      600: "#052403",
      700: "#041C02",
      800: "#031501",
      900: "#021000",
    },
    brandScheme: {
      100: "#E8F6E3",
      200: "#8BE15A",
      300: "#4FA03A",
      400: "#1F5A1C",
      500: "#073205",
      600: "#052403",
      700: "#041C02",
      800: "#031501",
      900: "#021000",
    },
    brandTabs: {
      100: "#E8F6E3",
      200: "#073205",
      300: "#073205",
      400: "#073205",
      500: "#073205",
      600: "#052403",
      700: "#041C02",
      800: "#031501",
      900: "#021000",
    },
    secondaryGray: {
      100: "#EDEEEC",
      200: "#E4E6E4",
      300: "#F6F7F9",
      400: "#E8EAE8",
      500: "#8A918B",
      600: "#6B726C",
      700: "#3D433E",
      800: "#3D433E",
      900: "#111812",
    },
    red: {
      100: "#FEEFEE",
      500: "#EE5D50",
      600: "#E31A1A",
    },
    blue: {
      50: "#EFF4FB",
      500: "#3965FF",
    },
    orange: {
      100: "#FFF6DA",
      500: "#FFB547",
    },
    green: {
      100: "#E8F6E3",
      500: "#4FA03A",
    },
    navy: {
      50: "#E8F6E3",
      100: "#D4E8C8",
      200: "#A8C4A0",
      300: "#6B8F66",
      400: "#3D5C38",
      500: "#1F5A1C",
      600: "#111812",
      700: "#111812",
      800: "#073205",
      900: "#041C02",
    },
    gray: {
      100: "#F6F7F9",
    },
  },
  fonts: {
    heading: `'IBM Plex Sans', sans-serif`,
    body: `'IBM Plex Sans', sans-serif`,
  },
  styles: {
    global: (props) => ({
      body: {
        overflowX: "hidden",
        bg: mode("secondaryGray.300", "navy.900")(props),
        color: mode("secondaryGray.900", "white")(props),
        fontFamily: "'IBM Plex Sans', sans-serif",
        letterSpacing: "0.01em",
      },
      input: {
        color: mode("gray.700", "white")(props),
      },
      html: {
        fontFamily: "'IBM Plex Sans', sans-serif",
      },
    }),
  },
};
